var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-position",attrs:{"src":require('@/assets/Experience.svg'),"width":"15px","alt":"Experience"}})
}
var staticRenderFns = []

export { render, staticRenderFns }